import React from 'react';
import { sortBy } from 'lodash';

import firebase from '../../firebase';
import useCollectionSubscriptionInTenant from '../hooks/useCollectionSubscriptionInTenant';
import { iconSizePx } from './IconDecorator';

const db = firebase.firestore();
export const rteIconsRef = db.collection('rteIcons');

// グリッドのサムネは実挿入サイズと無関係に一定。lg より少し大きくして選びやすくする。
const THUMB_PX = 72;

export default function IconLibrary(props) {
  const { selectedUrl, onSelect } = props;
  const icons = sortBy(
    useCollectionSubscriptionInTenant(rteIconsRef),
    _ => -(_.createdAt?.toDate?.()?.getTime() ?? 0),
  );

  if (icons.length === 0) {
    return (
      <div className="text-muted text-center py-4">
        保存されたアイコンはありません。<br />
        「アップロード」から追加すると、次回以降ここから選べます。
      </div>
    );
  }

  return (
    <div className="d-flex flex-wrap" style={{ gap: 8, maxHeight: 320, overflowY: 'auto' }}>
      {
        icons.map(({ id, url, fileName }) => (
          <button
            key={id}
            type="button"
            title={fileName}
            onClick={_ => onSelect(url)}
            className={`btn p-1 ${url === selectedUrl ? 'btn-primary' : 'btn-light border'}`}
          >
            <img
              src={url}
              alt={fileName}
              style={{ width: THUMB_PX, height: THUMB_PX, objectFit: 'contain' }}
            />
          </button>
        ))
      }
    </div>
  );
}
